import { Routes } from '@angular/router';
import { DashboardComponent, FirstStepsComponent } from '@app/app-components';
import { AuthGuard, BreadCrumbRouteConfig, RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesWorkspace: Routes = [
  {
    path: 'primeiros_passos',
    canActivate: [AuthGuard],
    component: FirstStepsComponent,
    data: {
      breadcrumb: {
        label: 'Primeiros passos',
        icon: 'mdi mdi-shoe-print'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'workspace',
    canActivate: [RenderInterfaceGuard],
    component: DashboardComponent,
    data: {
      breadcrumb: {
        label: 'Dashboard',
        icon: 'pi pi-fw pi-chart-bar',
        disableElement: true
      } as BreadCrumbRouteConfig
    }
  }
];
